  const RUBIES_PRODUCT_CARD_VARIANT_CHANGE_EVENT = "rubies-product-card-variant-change";

  const generateSrcset = (image, widths = []) => {
    const imageUrl = new URL(image["src"]);
    return widths.filter((width) => width <= image["width"]).map((width) => {
      imageUrl.searchParams.set("width", width.toString());
      return `${imageUrl.href} ${width}w`;
    }).join(", ");
  }

  const createImageElement = (image, classes, sizes, productTitle) => {
    const previewImage = image["preview_image"];
    const newImage = new Image(previewImage["width"], previewImage["height"]);
    newImage.className = classes;
    newImage.alt = image["alt"] || productTitle;
    newImage.sizes = sizes;
    newImage.src = previewImage["src"];
    newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
    newImage.loading="lazy"
    return newImage;
  }

  const createImageElementFromUrl = (imageUrl, classes, sizes, productTitle) => {
    const newImage = new Image();
    newImage.className = classes;
    newImage.alt = productTitle || "";
    newImage.sizes = sizes || "";
    newImage.src = imageUrl;
    newImage.loading = "lazy";
    return newImage;
  }

  const getImagePathname = (imageUrl) => {
    try {
      return new URL(imageUrl, window.location.href).pathname;
    } catch {
      return imageUrl;
    }
  }

  const replacePrimaryImage = (primaryImage, secondaryImage, newPrimaryImage) => {
    if (!primaryImage || !newPrimaryImage?.src) return;

    if (getImagePathname(newPrimaryImage.src) === getImagePathname(primaryImage.src)) return;

    let flag = false;
    if (secondaryImage) {
      const secondaryImagePathname = getImagePathname(secondaryImage.src);
      const newPrimaryImagePathname = getImagePathname(newPrimaryImage.src);

      if (secondaryImagePathname == newPrimaryImagePathname) {
        primaryImage.remove();
        secondaryImage.classList.remove('media--second');
        secondaryImage.classList.add('media--first');
        flag = true;
      }
    }
    if (flag == false) {
      primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" }).finished;
      setTimeout(function(){
        primaryImage.replaceWith(newPrimaryImage);
        newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
        if (secondaryImage) {
          secondaryImage.remove();
        }
      }, 200);
    }
  }

  const updateCardImageFromUrl = (wrapper, imageUrl, productTitle) => {
    const primaryImage = wrapper.querySelector(".media--first");
    if (!primaryImage || !imageUrl) return;

    const secondaryImage = wrapper.querySelector(".media--second");
    const newPrimaryImage = createImageElementFromUrl(imageUrl, primaryImage.className, primaryImage.sizes, productTitle);
    replacePrimaryImage(primaryImage, secondaryImage, newPrimaryImage);
  }

  const handleRubiesProductCardVariantChange = (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (!event.detail?.swapImage) return;
    const wrapper = target.closest('.js-color-swatches-wrapper');
    const imageUrl = event.detail?.imageUrl;
    if (!wrapper || !imageUrl) return;

    const productTitle = event.detail?.variantTitle || wrapper.querySelector('.card__title')?.textContent?.trim() || "";
    updateCardImageFromUrl(wrapper, imageUrl, productTitle);
  }

  const checkSwatches = () => {
    document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
      wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
        input.addEventListener('click', (event) => {
          const primaryImage = wrapper.querySelector(".media--first");
          const secondaryImage = wrapper.querySelector(".media--second");
          const handleProduct = wrapper.dataset.product;
          
          if (event.currentTarget.checked && primaryImage) {
            wrapper.querySelector('.js-color-swatches-link').setAttribute('href', event.currentTarget.dataset.variantLink);
            if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
              wrapper.querySelector('.card__add-to-cart button[name="add"]').setAttribute('aria-disabled', false);
              wrapper.querySelector('.card__add-to-cart button[name="add"] > span').classList.remove('hidden');
              wrapper.querySelector('.card__add-to-cart button[name="add"] .sold-out-message').classList.add('hidden');
              wrapper.querySelector('.card__add-to-cart input[name="id"]').value = event.currentTarget.dataset.variantId;
            }
            
            const currentColor = event.currentTarget.value;

            jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function(product) {
              const variant = product.variants.filter(item => item.featured_media != null && item.options.includes(currentColor))[0];

              if (variant) {
                const newPrimaryImage = createImageElement(variant["featured_media"], primaryImage.className, primaryImage.sizes, product.title);
                replacePrimaryImage(primaryImage, secondaryImage, newPrimaryImage);
              }
            });
          }
        })
      })
    })
  }

  function colorSwatches() {
    checkSwatches();

    document.addEventListener('shopify:section:load', function () {
      checkSwatches();
    });
  }

(function () {
  document.addEventListener(RUBIES_PRODUCT_CARD_VARIANT_CHANGE_EVENT, handleRubiesProductCardVariantChange);
  colorSwatches();
})()
